import { Translate } from '@teliaee/telia-translate';
import { IChannel } from 'telia-front-react';
import { TvChannel } from '../stores/TvChannelsStore';

const DEFAULT_CHANNEL_IMAGE = 'https://www.telia.ee/images/images/dtv-icons/default.png';

export const createCloudinarySrcset = (url: string, size?: 'small' | 'medium' | 'large', maxAllowedWidth?: number): string => {
  let widths = ['17', '34'];
  if (size === 'small') {
    widths = ['24', '48'];
  } else if (size === 'medium') {
    widths = !!maxAllowedWidth && maxAllowedWidth < 88 ? ['44'] : ['44', '88'];
  } else if (size === 'large') {
    widths = !!maxAllowedWidth && maxAllowedWidth < 148 ? ['74'] : ['74', '148'];
  }
  return widths.map((s) => `https://res.cloudinary.com/telia/image/fetch/f_auto,fl_lossy,q_auto:best,w_${s}/${url} ${s}w`).join(',');
};

export const prepareChannels = (channels: TvChannel[], translate: Translate, size: 'small' | 'medium' | 'large', iconSize?: string): IChannel[] => {
  return channels.map((channel) => ({
    ...channel,
    image: {
      srcset: resolveImage(channel, size, iconSize),
      alt: channel.title,
    },
    meta:
      channel.meta &&
      channel.meta.map((meta) => ({
        ...meta,
        label: translate(`tvChannel.meta.${meta.label}`) || meta.label,
      })),
  }));
};

export const resolveImage = (channel: TvChannel, size: 'small' | 'medium' | 'large', iconSize?: string) => {
  if (channel.image) {
    return createCloudinarySrcset(channel.image, size);
  }
  if (!channel.icons) {
    return createCloudinarySrcset(DEFAULT_CHANNEL_IMAGE, size);
  }

  if (iconSize && channel.icons[iconSize]) {
    return createCloudinarySrcset(channel.icons[iconSize], size);
  }

  return (
    (channel.icons['300x300'] && createCloudinarySrcset(channel.icons['300x300'], size)) ||
    (channel.icons['190x150'] && createCloudinarySrcset(channel.icons['190x150'], size)) ||
    (channel.icons['165x165'] && createCloudinarySrcset(channel.icons['165x165'], size)) ||
    (channel.icons['90x90'] && createCloudinarySrcset(channel.icons['90x90'], size, 90)) ||
    (channel.icons['90x40'] && createCloudinarySrcset(channel.icons['90x40'], size, 90)) ||
    (channel.icons['72x49'] && createCloudinarySrcset(channel.icons['72x49'], size, 72)) ||
    (channel.icons['87x46'] && createCloudinarySrcset(channel.icons['87x46'], size, 87))
  );
};
